import { gql } from '@apollo/client';

export const REQUEST_UPLOAD_URL = gql`
  mutation RequestUploadUrl($filename: String!, $mimeType: String!, $sizeBytes: Int!, $kind: String!) {
    requestUploadUrl(filename: $filename, mimeType: $mimeType, sizeBytes: $sizeBytes, kind: $kind) {
      uploadUrl
      storageKey
      expiresIn
    }
  }
`;

export const SUBMIT_FEEDBACK = gql`
  mutation SubmitFeedback($input: FeedbackInput!) {
    submitFeedback(input: $input) {
      feedback {
        id
        type
        status
        title
        createdAt
        countsTowardRewards
      }
      user {
        id
        contributionCount
        plusEntitlementUntil
        plusLifetime
        proTrialUntil
        connectBetaPriority
      }
      milestonesReached {
        count
        label
      }
    }
  }
`;

export const ACCEPT_TERMS = gql`
  mutation AcceptTerms($acceptedAtIso: String!) {
    acceptTerms(acceptedAtIso: $acceptedAtIso) {
      id
      termsAcceptedVersion
      termsAcceptedAt
      termsAcceptedAtIso
      privacyAcceptedVersion
      privacyAcceptedAt
      privacyAcceptedAtIso
    }
  }
`;

export const SET_WHATSAPP = gql`
  mutation SetWhatsapp($whatsapp: String!, $optIn: Boolean!) {
    setWhatsapp(whatsapp: $whatsapp, optIn: $optIn) {
      id
      whatsapp
      whatsappOptIn
    }
  }
`;

export const MY_FEEDBACKS = gql`
  query MyFeedbacks {
    myFeedbacks {
      id
      type
      status
      title
      body
      specieId
      meta
      countsTowardRewards
      answer
      answeredAt
      createdAt
      evidences {
        id
        kind
        storageKey
        linkType
        linkValue
        label
        mimeType
      }
    }
  }
`;

export const FEEDBACK_QUEUE = gql`
  query FeedbackQueue($type: String, $status: String, $limit: Int) {
    feedbackQueue(type: $type, status: $status, limit: $limit) {
      id
      type
      status
      title
      body
      specieId
      meta
      countsTowardRewards
      answer
      createdAt
      user { id fullName email phone }
      evidences { id kind storageKey linkType linkValue label mimeType }
    }
  }
`;

export const INVALIDATE_FEEDBACK = gql`
  mutation InvalidateFeedback($id: Int!, $reason: String) {
    invalidateFeedback(id: $id, reason: $reason) { id status countsTowardRewards reviewerNote }
  }
`;

export const ANSWER_QUESTION = gql`
  mutation AnswerQuestion($id: Int!, $answer: String!) {
    answerQuestion(id: $id, answer: $answer) { id status answer answeredAt }
  }
`;

export const LEGAL_DOCUMENTS = gql`
  query LegalDocuments {
    legalDocuments { termsVersion privacyVersion }
  }
`;
